import { useContext } from "react";
import AuthContext from "../contexts/SessionContext";

const useAuth = () => useContext(AuthContext);

export default useAuth;
